import React from "react";
import PropTypes from "prop-types";
import * as S from "./styles";

export const FieldCheckbox = ({
  id,
  label,
  value,
  handleChange,
  readOnly,
  hidden,
  defaultValue,
  centered,
  titleWeight = "normal", // "bold" | "semibold" | "normal"
}) => {
  return (
    <S.Container className={hidden ? "hidden" : "visible"}>
      
      {label && <S.Label $weight= {titleWeight}>{label}</S.Label>}
      <S.CheckboxContainer centered={centered}>
        <S.Input
          type="checkbox"
          value={value}
          checked={value}
          defaultChecked={defaultValue}
          disabled={readOnly}
          onChange={(e) => handleChange(id, e.target.checked)}
        />
      </S.CheckboxContainer>
    </S.Container>
  );
};

FieldCheckbox.propTypes = {
  modulo: PropTypes.string,
  propiedad: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.bool,
  handleChange: PropTypes.func,
  readOnly: PropTypes.bool,
  hidden: PropTypes.bool,
  centered: PropTypes.bool,
};
